import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-mobiliare-view',
  templateUrl: './form-mobiliare-view.component.html',
  styleUrls: ['./form-mobiliare-view.component.css']
})
export class FormMobiliareViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
